function _templateObject() {
  var data = _taggedTemplateLiteral(["\n     & ", " {\n      opacity: 1;\n     }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from 'styled-components';
import colors from "../../colors";
import { mediaSmUp } from "../../theme/helpers/media";
import { CardNote } from "./components/CommentField";
import Controls from "./components/Controls";
import Box from "../Grid/Box";
import Flex from "../Grid/Flex";
import { addStyleIfPropTruly } from "../../utils/styledComponents";
export var RelativeBox = styled(Box).withConfig({
  displayName: "styled__RelativeBox",
  componentId: "sc-1y4swt4-0"
})(["position:relative;"]);
export var ImageWrapper = styled(Flex).attrs({
  mb: 0,
  center: true,
  middle: true
}).withConfig({
  displayName: "styled__ImageWrapper",
  componentId: "sc-1y4swt4-1"
})(["position:relative;", ""], function (_ref) {
  var borderRadius = _ref.theme.borderRadius,
      withFullImage = _ref.withFullImage;
  return withFullImage && addStyleIfPropTruly('withFullImage', "\n        overflow: hidden;\n        border-radius: ".concat(borderRadius, "px;\n        background-color: ").concat(colors.ghostWhite, ";\n        "));
});
export var hoverStyles = css(["outline:none;z-index:1;", "{z-index:2;opacity:1;visibility:visible;}", ""], CardNote, mediaSmUp(_templateObject(), Controls));